import { render, staticRenderFns } from "./Processes-list.vue?vue&type=template&id=17dc35b7&"
import script from "./Processes-list.vue?vue&type=script&lang=js&"
export * from "./Processes-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports